<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs3-09",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 50,
      nextPage: '/questionnaire/section3/10',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'normalBtn'
        },
        mainTitle: 'How often do you drink per week?',
        btn: [
          [
            {
              text: '1 or none',
            }
          ],[
            {
              text: '2-3',
              operation: 'flag1-4_Prepare_add reminder 4 & flag1-4_Pregnancy_add reminder 15 & flag1-4_Lactation_add reminder 16'
            }
          ],[
            {
              text: '4 or more',
              operation: 'flag3-1_Anything_add suggestion 11 & flag1-4_Prepare_add reminder 4 & flag1-4_Pregnancy_add reminder 15 & flag1-4_Lactation_add reminder 16'
            }
          ]
        ],
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
